export default __webpack_public_path__ + "static/media/pin-man-mou-temple.029eb049.png";